export default "__VITE_ASSET__ZTCT1nGf__"